
































































import {
  Vue, Component, Mixins, Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import ApiHelper from 'api-helper';
import { LpAnalyticsModule } from '@/store';
import DatePickerMixin from '@/common/mixins/DatePickerMixin';
import ContentLayout from '@components/layouts/Content.vue';
import BaseDatePicker from '@/components/common/BaseDatePicker.vue';
import Toast from '@/common/helpers/toast';
import chartLineIcon from '@/assets/img/chartLineIcon.svg';

import moment from 'moment';
import Encoding from 'encoding-japanese';

@Component({
  name: 'LpAnalyticsList',
  components: {
    BaseDatePicker,
    ContentLayout,
  },
  data() {
    return {
      iconHeader: chartLineIcon,
    };
  },
})
export default class LpAnalyticsList extends Mixins(DatePickerMixin) {
  @State((state) => state.lpAnalytics.list) list!: any[];
  @State((state) => state.lpAnalytics.isLoading) isLoading!: boolean;

  dateFrom: string = '';
  dateTo: string = '';
  isExporting: boolean = false;

  columns = [
    {
      title: 'クリニック名',
      dataIndex: 'clinic_name',
      key: 'clinic_name',
    },
    {
      title: 'PV数',
      dataIndex: 'pv_count',
      key: 'pv_count',
    },
    {
      title: 'ユニークユーザー数',
      dataIndex: 'uu_count',
      key: 'uu_count',
    },
    {
      title: '問診遷移クリック数',
      dataIndex: 'click_count',
      key: 'click_count',
    },
    {
      title: '離脱数',
      dataIndex: 'bounce_count',
      key: 'bounce_count',
    },
    {
      title: '平均滞在時間',
      dataIndex: 'avg_time_on_page_ms',
      key: 'avg_time_on_page_ms',
      customRender: (value: number | null) => this.formatDuration(value),
    },
    {
      title: 'スクロール到達率',
      dataIndex: 'scroll_depth',
      key: 'scroll_depth',
      customRender: (_value: any, row: any) => this.renderMetricGrid([
        { label: '25', value: this.formatPct(row.scroll_25_count, row.pv_count || 0) },
        { label: '50', value: this.formatPct(row.scroll_50_count, row.pv_count || 0) },
        { label: '75', value: this.formatPct(row.scroll_75_count, row.pv_count || 0) },
        { label: '100', value: this.formatPct(row.scroll_100_count, row.pv_count || 0) },
      ]),
    },
    {
      title: '端末別',
      dataIndex: 'device_type',
      key: 'device_type',
      customRender: (_value: any, row: any) => this.renderMetricGrid([
        { label: 'Mobile', value: this.formatPct(row.mobile_count, row.pv_count || 0) },
        { label: 'PC', value: this.formatPct(row.pc_count, row.pv_count || 0) },
        { label: 'Tablet', value: this.formatPct(row.tablet_count, row.pv_count || 0) },
      ]),
    },
  ];

  @Watch('dateFrom')
  onDateFromChange(): void {
    if (this.dateFrom && this.dateTo && moment(this.dateTo).isBefore(this.dateFrom, 'date')) {
      this.dateTo = '';
      Toast.error('終了日は開始日以降の日付を選択してください');
    }
  }

  mounted() {
    this.fetchList();
  }

  onSearch(): void {
    this.fetchList();
  }

  disabledDateFrom(date: any): boolean {
    if (!this.dateTo) {
      return false;
    }
    return moment(date).isAfter(this.dateTo, 'date');
  }

  disabledDateTo(date: any): boolean {
    if (!this.dateFrom) {
      return false;
    }
    return this.handleMinDate(date, this.dateFrom);
  }

  get queryParams() {
    const params: { date_from?: string; date_to?: string; order: string } = {
      order: '-created_at',
    };
    if (this.dateFrom) {
      params.date_from = this.dateFrom;
    }
    if (this.dateTo) {
      params.date_to = this.dateTo;
    }
    return params;
  }

  async fetchList() {
    try {
      await LpAnalyticsModule.fetchList(this.queryParams);
    } catch (e) {
      const error: any = e;
      if (error.response) {
        Toast.error(error.response.data.message);
      }
    }
  }

  formatDuration(ms: number | null): string {
    if (ms === null || ms === undefined) {
      return '-';
    }
    const totalSeconds = Math.round(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
  }

  formatPct(count: number, total: number): string {
    if (!total) {
      return '0%';
    }
    return `${Math.round((count / total) * 100)}%`;
  }

  renderMetricGrid(items: Array<{ label: string; value: string }>) {
    const h = this.$createElement;
    const maxValue = Math.max(...items.map((item) => parseInt(item.value, 10) || 0));

    return h(
      'div',
      { class: 'metric-grid' },
      items.map((item) => h('div', { class: 'metric-cell' }, [
        h('div', { class: 'metric-label' }, item.label),
        h(
          'div',
          {
            class: [
              'metric-value',
              (parseInt(item.value, 10) || 0) === maxValue && maxValue > 0 ? 'metric-value--highlight' : '',
            ],
          },
          item.value,
        ),
      ])),
    );
  }

  transformBlobToFile(data, file) {
    const uniArray = Encoding.stringToCode(data);
    const sjisArray = Encoding.convert(uniArray, {
      to: 'SJIS',
      from: 'UNICODE',
    });
    const unit8Array = new Uint8Array(sjisArray);
    const blob = new Blob([unit8Array], { type: 'text/csv;charset=Shift_JIS' });

    if ((window.navigator as any).msSaveOrOpenBlob) {
      // for IE,Edge
      (window.navigator as any).msSaveOrOpenBlob(blob, file);
    } else {
      // for chrome, firefox
      const url = URL.createObjectURL(blob);
      const linkEl: any = document.createElement('a');
      linkEl.href = url;
      linkEl.setAttribute('download', file);
      document.body.appendChild(linkEl);
      linkEl.click();

      URL.revokeObjectURL(url);
      linkEl.parentNode.removeChild(linkEl);
    }
  }

  async exportCsv() {
    if (this.isExporting) {
      return;
    }

    this.isExporting = true;

    try {
      const res = await ApiHelper.getApi('LpAnalyticsApi').getLpAnalyticsExport(
        this.queryParams,
      );

      this.transformBlobToFile(
        res,
        `LpAnalytics_${moment().format('YYYY年MM月DD日')}.csv`,
      );
    } catch (e) {
      const error: any = e;
      if (error.response) {
        Toast.error(error.response.data.message);
      }
    } finally {
      this.isExporting = false;
    }
  }
}
